import { render } from "./Billing.vue?vue&type=template&id=8080db94"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mahoro\\projects\\crane\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__